import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';
import usePrimaryCtaButtonState from '../selectors/usePrimaryCtaButtonState';

function useTrackPrimaryCtaRenderPerformance() {
  const { isLoading } = usePrimaryCtaButtonState();
  const hasLogged = useRef(false);

  useEffect(() => {
    if (!isLoading && !hasLogged.current) {
      datadogRum.addAction('Primary CTA loaded', {
        value: Math.round(performance.now())
      });

      hasLogged.current = true;
    }
  }, [isLoading]);
}

export default useTrackPrimaryCtaRenderPerformance;
